module.exports = [{"id":"app-data","src":"data/data.json"}]


//////////////////
// WEBPACK FOOTER
// ./src/scripts/data/loader-common.json
// module id = 9
// module chunks = 0